import React, {useEffect, useState} from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import Header from "../components/Header"
import BreadCrumbs from "../components/BreadCrumbs"
import CustomSelect from "../components/CustomSelect"
import {apiUsers, apiUsersEdit} from "api-methods"
import Notification from "../components/Notification"
import '../css/UserManagement.css'
import { handleAuthErrorAndRedirect, isSuccessStatus } from '../utils/authError'

const UserManagement = () => {
    const [users, setUsers] = useState([])
    const navigate = useNavigate()
    const location = useLocation()
    const [notification, setNotification] = useState(null)

    useEffect(() => {
        apiUsers()
            .then(data => {
                if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location})) return
                if (isSuccessStatus(data.code)) {
                    if (typeof data.data === 'string') {data.data = JSON.parse(data.data)}
                    // Убедимся, что data.data - это массив
                    setUsers(Array.isArray(data.data) ? data.data : [])
                }
            })
            .catch(_ => {
                // В случае ошибки устанавливаем пустой массив
                setUsers([])
            })
    }, [navigate, location])

    const showNotification = (message, type = 'success') => {setNotification({ message, type })}
    const hideNotification = () => {setNotification(null)}

    const handleRoleChange = (userId, roleId) => {
        setUsers(prevUsers => prevUsers.map(user => user.userId === userId ? {...user, roles: user.roles.map(role => role.roleId === roleId ? { ...role, isBind: true } : { ...role, isBind: false })} : user))
        let updatedUser = users.find(user => user.userId === userId)
        let forApiReq = [{"userId": updatedUser.userId, "isActive": updatedUser.isActive, "roleId": roleId}]

        apiUsersEdit(forApiReq)
            .then(data => {
                if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location})) return
                if (isSuccessStatus(data.code)) {showNotification('Данные успешно сохранены!', 'success')} else {showNotification('Ошибка сохранения!', 'error')}
            })
            .catch(_ => {showNotification('Ошибка сохранения!', 'error')})
            .finally(_ => {})
    }

    const handleStatusChange = (userId, isActive) => {
        setUsers(prevUsers => prevUsers.map(user => user.userId === userId ? { ...user, isActive: isActive === 'true' } : user))
        let updatedUser = users.find(user => user.userId === userId)
        let updatedUserRole = updatedUser.roles.find(role => role.isBind)?.roleId || updatedUser.roles[0]?.roleId
        let forApiReq = [{"userId": updatedUser.userId, "isActive": isActive, "roleId": updatedUserRole}]

        apiUsersEdit(forApiReq)
            .then(data => {
                if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location})) return
                if (isSuccessStatus(data.code)) {showNotification('Данные успешно сохранены!', 'success')} else {showNotification('Ошибка сохранения!', 'error')}
            })
            .catch(_ => {showNotification('Ошибка сохранения!', 'error')})
            .finally(_ => {})
    }

    return (
        <div className="pageUserManagement">
            <Header/>
            <BreadCrumbs title={'Пользователи'} />
            <div className="pageUserManagementContent">
                <div className="users-table-container">
                    <table className="users-table">
                        <thead>
                        <tr className="table-header">
                            <th scope="col">ID</th>
                            <th scope="col">Имя</th>
                            <th scope="col">Фамилия</th>
                            <th scope="col">E-mail</th>
                            <th scope="col">Уровень доступа</th>
                            <th scope="col">Статус</th>
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        {/* Безопасная проверка наличия users и что это массив */}
                        {users && users.length > 0 ? (
                            users.map(user => (
                                <tr key={user.userId} className="table-row">
                                    <td data-label="ID">{user.userId}</td>
                                    <td data-label="Имя">{user.userName}</td>
                                    <td data-label="Фамилия">{user.userLastName}</td>
                                    <td data-label="E-mail">{user.userEmail}</td>
                                    <td data-label="Уровень доступа">
                                        <CustomSelect
                                            value={user.roles?.find(role => role.isBind)?.roleId || ''}
                                            options={user.roles || []}
                                            onChange={(value) => handleRoleChange(user.userId, parseInt(value))}
                                            className="role-select"
                                        />
                                    </td>
                                    <td data-label="Статус">
                                        <CustomSelect
                                            value={user.isActive?.toString() || 'false'}
                                            options={[
                                                { roleId: 'true', roleName: 'Активен' },
                                                { roleId: 'false', roleName: 'Неактивен' }
                                            ]}
                                            onChange={(value) => handleStatusChange(user.userId, value)}
                                            className="status-select"
                                            optionLabelKey="roleName"
                                            optionValueKey="roleId"
                                        />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                                    Нет данных для отображения
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

                {/* Уведомление */}
                {notification && (
                    <Notification
                        message={notification.message}
                        type={notification.type}
                        onClose={hideNotification}
                        duration={3000}
                    />
                )}
            </div>
        </div>
    )
}

export default UserManagement

